import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSupportsVisitFiltering } from 'store/ui-metadata/hooks';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const useTabs = useSupportsVisitFiltering();
  const listMode = useTabs ? 'upcoming' : 'all';

  // Use Navigate component directly - this is declarative and prevents loops
  // Navigate will only redirect when this component is rendered (i.e., when no route matches)
  return <Navigate to={listMode} replace />;
};
